module.exports = __webpack_public_path__ + "static/media/seminars-secondary.3488b965.jpg";